import { useMemo, Fragment } from 'react'

import { DropdownMenuSeparator } from '@dc-shared-web/components/shadcn/dropdown-menu'

import {
  UserNotification,
  useUserNotifications,
} from '@/app/core/providers/UserNotificationProvider'

import NotificationInboxEmpty from '@/app/core/components/notification/NotificationInboxEmpty'
import ThreadNotification from '@/app/core/components/notification/ThreadNotification'
import AssignmentNotification from '@/app/core/components/notification/AssignmentNotification'
import {
  isNotificationUnread,
  isUserAssignedCustomNotification,
  isUserUnassignedCustomNotification,
  isUserAssignmentRemovedCustomNotification,
} from '@/app/core/components/notification/utils'
import AssignmentRemovedNotification from '@/app/core/components/notification//AssignmentRemovedNotification'

const NotificationContent = ({
  notification,
  onClick,
}: {
  notification: UserNotification
  onClick: () => void
}) => {
  if (notification.kind === 'thread') {
    return <ThreadNotification notification={notification} onClick={onClick} />
  }

  if (
    isUserAssignedCustomNotification(notification) ||
    isUserUnassignedCustomNotification(notification)
  ) {
    return (
      <AssignmentNotification notification={notification} onClick={onClick} />
    )
  }
  if (isUserAssignmentRemovedCustomNotification(notification)) {
    return (
      <AssignmentRemovedNotification
        notification={notification}
        onClick={onClick}
      />
    )
  }

  return null
}

export default function NotificationInbox({
  onlyShowUnread,
  onNavigateToComment,
}: {
  onlyShowUnread: boolean
  onNavigateToComment: () => void
}) {
  const { notifications } = useUserNotifications()

  const filteredNotifications = useMemo(() => {
    // TODO: Filter notifications for removed checklists ?
    return onlyShowUnread
      ? notifications?.filter((notification) =>
          isNotificationUnread(notification)
        )
      : notifications
  }, [notifications, onlyShowUnread])

  if (filteredNotifications.length === 0) {
    return <NotificationInboxEmpty />
  }

  return (
    <div
      className='tw-grow tw-overflow-y-auto tw-overflow-x-hidden tw-flex tw-flex-col last:tw-rounded-b-xl'
      data-testid='notifications-inbox'
    >
      {filteredNotifications.map((notification, index) => (
        <Fragment key={notification.id}>
          <NotificationContent
            notification={notification}
            onClick={onNavigateToComment}
          />
          {index < filteredNotifications.length - 1 && (
            <DropdownMenuSeparator className='tw-m-0' />
          )}
        </Fragment>
      ))}
    </div>
  )
}
